import {
    FETCH_SERVICE_ORDER_PRODUCTION_STATISTICS,
    FETCH_SERVICE_ORDER_TIRE_MODEL_STATISTICS,
    FETCH_SERVICE_ORDER_TIRE_STATISTICS,
    RECEIVE_SERVICE_ORDER_PRODUCTION_STATISTICS, RECEIVE_SERVICE_ORDER_TIRE_MODEL_STATISTICS,
    RECEIVE_SERVICE_ORDER_TIRE_STATISTICS
} from '../actions/actionTypes'
import dataObjectFromFile from "../assets/mock/1/state0.json";

const initialState = () => {


    const at = localStorage.getItem('accessToken');
    if (at && at == "mock") {
        return {
            ...dataObjectFromFile.serviceOrderStatistics
        }
    }


    return {
        productionStatistics: [],
        tireStatistics: {
            tireBrands: [],
            tireModels: {recebidos: [], finalizados: []},
            tireBands: [],
            tireSizes: []
        }
    }
}

export default (state = initialState(), action) => {
    switch(action.type) {
        case FETCH_SERVICE_ORDER_PRODUCTION_STATISTICS:
            return {
                ...state,
                isFetchingServiceOrderProductionStatistics: true,
                productionStatistics: []
            }
        case RECEIVE_SERVICE_ORDER_PRODUCTION_STATISTICS:
            return {
                ...state,
                isFetchingServiceOrderProductionStatistics: false,
                productionStatistics: action.payload
            }
        case FETCH_SERVICE_ORDER_TIRE_STATISTICS:
            return {
                ...state,
                isFetchingServiceOrderProductionStatistics: true,
                tireStatistics: initialState().tireStatistics
            }
        case RECEIVE_SERVICE_ORDER_TIRE_STATISTICS:
            return {
                ...state,
                isFetchingServiceOrderProductionStatistics: false,
                tireStatistics: action.payload
            }

        default:
            return state;
    }
}
